export default "__VITE_ASSET__e65b483a__"